import { getWindowObject } from '@eventbrite/feature-detection';
import { getLocale, getLocaleOverride } from '@eventbrite/i18n';
import { StatsigUser } from '@eventbrite/statsig';
import pickBy from 'lodash/pickBy';
import { CheckoutState } from '../state';
import { AppNamespace } from '../state/app';

export const getDefaultUserCountry = (state: CheckoutState): string =>
    state.app.defaultUserCountry;

export const getEbDomain = (state: CheckoutState) => state.app?.ebDomain;

export const getActiveFFsFromCore = ({ app }: CheckoutState) => {
    return Object.keys(
        pickBy(app.featureFlags, (value: any) =>
            typeof value === 'object' ? value.isActive : !!value,
        ),
    ).sort();
};

export const getFeatureFlags = ({ app }: CheckoutState) => ({
    featureFlags: app.featureFlags,
});

export const getLocaleProps = ({ app, event }: CheckoutState) => {
    return {
        locales: app.locales,
        defaultLocale:
            getLocaleOverride() ??
            getLocale({
                eventLocale:
                    ('properties' in event && event.properties.locale) || '',
                appLocale: app.locale,
            }),
    };
};

export const isEventbriteTLD = (state: CheckoutState): boolean =>
    state.app.isEventbriteTLD;

export const isTosClickWrapVisible = (state: CheckoutState): boolean =>
    !!state.app?.featureFlags?.enableCheckoutTosClickwrap;

export const getGooglePayEnvironment = (state: CheckoutState) => {
    return state.app.isProd ? 'PRODUCTION' : 'TEST';
};

export const getInitialStatsigCustomUserConfig = (
    app: AppNamespace,
): StatsigUser => {
    const { userAgent } = getWindowObject('navigator') ?? {};

    return {
        custom: {
            eventId: app.event?.id,
            isEventbriteTLD: app.isEventbriteTLD,
            ...(userAgent
                ? { userAgentLowerCase: userAgent.toLowerCase() }
                : {}),
            useAndroidProfile: app.useAndroidProfile,
            useIosProfile: app.useIosProfile,
        },
        customIDs: {
            correlationId: app.request?.correlation_id,
            eventId: app.event?.id,
            organizerId: app.event?.organizer_id,
            sessionId: app.request?.session_id,
        },
    };
};
